// extracted by mini-css-extract-plugin
export default {"container":"Card_container__n6X5P","cancel":"Card_cancel__O+Jb8"};